var Instagram = {};

(function ($) {

	var container = $('.js-instagram-container');

	Instagram.sliderInit = function (sliderClass) {
		if (!sliderClass) {
			return false;
		}

		var slideCount = 2;
		var rowMobile = 2;

		if($(sliderClass).hasClass('is-single')) {
			slideCount = 1;
			rowMobile = 1;
		}

		$(sliderClass).slick({
			arrows: false,
			dots: true,
			infinite: true,
			rows: 2,
			slidesPerRow: 4,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						rows: rowMobile,
						slidesPerRow: slideCount,
						slidesToScroll: 1,
					}
				}
			]
		});

	};


	Instagram.init = function () {
		var counter = 0;
		var url;

		$.ajax({
			url: ajaxURL,
			dataType: 'json',
			type: 'GET',
			data: { action: 'get_instagram' },
			success: function (result) {

				if (result.data.meta.code !== 200) {
					return;
				}
				url = result.data.pagination.next_url;

				for (var x in result.data.data) {
					counter++;

					if (counter > result.listing_count) {
						break;
					}

					var link = result.data.data[x].link;
					var image = result.data.data[x].images.low_resolution.url;

					var alt;

					if (typeof result.data.data[x].caption.text !== 'undefined') {
						// Replace double quotes
						String.prototype.replaceAll = function (search, replacement) {
							var target = this;
							return target.split(search).join(replacement);
						};

						alt = result.data.data[x].caption.text.replaceAll('"', '');
					} else {
						alt = 'Head Agent Instagram';
					}

					container.append('<div class="item-wrap"><a target="_blank" href="' + link + '" class="item" rel="nofollow noreferrer"><img src="' + image + '" alt="' + alt + '" /></a></div>');
				}

				if (counter >= result.listing_count || typeof result.data.pagination.next_url === 'undefined') {
					// Add Instagram logo at the end
					container.append('<div class="item-wrap"><div class="item has-icon"><a target="_blank" href="' + result.url + '" rel="nofollow noreferrer"><svg class="icon" viewBox="0 0 28 28" preserveAspectRatio="xMidYMid meet" aria-hidden="true"><use xlink:href="#icon--instagram" /></svg></a></div></div>');

					return;
				}

				// Get next batch of images
				if (typeof url !== 'undefined') {
					Instagram.init();
				}
				
				
			},
			complete: function (data) {
				Instagram.sliderInit('.js-instagram-slick');
			},
			error: function (result) {
				console.log(result);
			}
		});
		
	};

	if (container.length) {
		$(Instagram.init);
	}
})(jQuery);
